const menuFilter = () => {
	$('#js__menu_location').selectric();

	// Menu location z-index fix
	$('#js__menu_location').on('selectric-open', function (ev, el, selectric) {
		$('.menu__top').addClass('selectric-open');
	});
	$('#js__menu_location').on('selectric-close', function (ev, el, selectric) {
		$('.menu__top').removeClass('selectric-open');
	});

	// Check to see if we're using any custom URL params on load
	handleMenuURLParam(window.location.href);

	$('body').on('change', '#js__menu_location', function () {
		let ID = $(this).find(':selected').val();
		menuFilterCall(ID);
	});

	$('body').on('click', '.js__menu-filter', function (e) {
		e.preventDefault();
		let title = $(this).attr('data-title');
		let type = $(this).attr('data-type');
		let ID = $('#js__menu_location').find(':selected').val();
		$('.js__menu-filter').removeClass('active');
		$(this).addClass('active');

		menuFilterCallCat(title, ID, type);
	});

	$('body').on('click', '.js__open-filter, .filter__mobile--dropdown-top', function (e) {
		e.preventDefault();
		mobileMenuFilter();
	});

	$(window).on('scroll load resize', function (e) {
		e.preventDefault();

		if ($(window).width() < 992) {
			let scrollTop = $(window).scrollTop();
			const menuOffset = $('.menu.filter-section').offset().top - 90;

			console.log(scrollTop);
			console.log(menuOffset);

			if (scrollTop > menuOffset) {
				$('.menu').addClass('fix-filter');
				$('.menu .select-wrap').addClass('fix-filter');
				$('.menu .filter__mobile').addClass('fix-filter');
				$('.menu').css('padding-top', '250px');
			} else {
				$('.menu').removeClass('fix-filter');
				$('.menu .select-wrap').removeClass('fix-filter');
				$('.menu .filter__mobile').removeClass('fix-filter');
				$('.menu').css('padding-top', '0');
			}
		} else {
			$('.menu').removeClass('fix-filter');
			$('.menu .select-wrap').removeClass('fix-filter');
			$('.menu .filter__mobile').removeClass('fix-filter');
			$('.menu').css('padding-top', '0');
		}
	});
};

const mobileMenuFilter = () => {
	let filter = $('.js__open-filter');
	let cats = $('.filter__mobile--dropdown');
	let header = $('.c-header');
	let wrap = $('.menu__wrap');
	const menuMain = $('.menu__main');

	if (filter.hasClass('active')) {
		menuMain.removeClass('filter-open');
		filter.removeClass('active');
		cats.removeClass('open');
		header.css('zIndex', '99');
	} else {
		menuMain.addClass('filter-open');
		header.css('zIndex', '0');
		filter.addClass('active');
		cats.addClass('open');
	}
};

const menuFilterCallCat = (title, ID, type) => {
	mobileMenuFilter();
	let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';
	let wrapper = $('.js-menu-category-container');
	let wrapperHeight = wrapper.innerHeight();
	$.ajax({
		url: '/wp-admin/admin-ajax.php',
		type: 'POST',
		data: {
			action: 'create_menu_category_ajax',
			cat_title: title,
			menu_id: ID,
			type: type,
		},
		beforeSend: function () {
			$(wrapper).fadeTo(200, 0, function () {
				$('#loader').html(loader);
				wrapper.css('min-height', wrapperHeight + 'px');
				$(wrapper).empty();
			});
			$(wrapper).fadeTo(400, 1);
		},
		success: function (data) {
			$(wrapper).fadeIn(300, function () {
				$('#loader .loader').remove();
				wrapper.css('min-height', 'auto');
				$(wrapper).append(data);
				initScrollingAnimations();
			});
		},
	});
};

const menuFilterCall = (ID) => {
	let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';
	let wrapper = $('.js-menu-items-container');
	let wrapperHeight = wrapper.innerHeight();
	$.ajax({
		url: '/wp-admin/admin-ajax.php',
		type: 'POST',
		data: {
			action: 'create_menu_ajax',
			id: ID,
		},
		beforeSend: function () {
			wrapper.fadeTo(200, 0, function () {
				$('#loader').html(loader);
				wrapper.css('min-height', wrapperHeight + 'px');
				wrapper.empty();
			});
			$(wrapper).fadeTo(400, 1);
		},
		success: function (data) {
			wrapper.fadeIn(300, function () {
				$('#loader .loader').remove();
				wrapper.css('min-height', 'auto');
				wrapper.append(data);
			});
		},
	});
};

function handleMenuURLParam(href) {
	//#menu:LocationMenuID | Will load selected menu

	if (href.indexOf('#') != -1) {
		//Check if the link has a #
		let hashRaw = href.split('#')[1],
			hashValue = hashRaw.split(':');

		if (hashValue[0] == 'menu') {
			$('#js__menu_location').val(hashValue[1]).change().selectric('refresh'); //Make sure selectric shows the correct option

			menuFilterCall(hashValue[1]);
		} else {
			return false;
		}
	}
}
